<template>
  <div class="course-class-management">
    <div class="section-header">
      <h3>班级管理</h3>
      <!-- <div v-if="courseId && (role == 3 || role == 2)" class="class-actions">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="showAddCourseClassDialog">关联班级</el-button>
        <el-button
          type="success"
          size="small"
          icon="el-icon-check"
          @click="showBatchAddCourseClassDialog">批量关联</el-button>
      </div> -->
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="班级">
        <el-input v-model="formInline.searchTitle" placeholder="输入班级名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchExam">查询</el-button>
      </el-form-item> -->
      <el-form-item>
        <el-button v-if="role == 3 || role == 2" :title="diaTitle" type="primary" @click="dialogTableVisible = true">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="role == 2" type="primary" @click="joinClassVisible = true">加入班级</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button v-if="role == 3 || role == 2" type="primary" @click="addStudentVisible = true">添加学生</el-button>
      </el-form-item> -->
    </el-form>
    </div>

    <!-- table -->
    <el-table :data="data.records" border fit highlight-current-row :header-cell-style="{
      background: '#f2f3f4',
      color: '#555',
      'font-weight': 'bold',
      'line-height': '32px',
    }">
      <el-table-column label="序号" align="center" width="80px"><template slot-scope="scope">{{ scope.$index + 1 }}</template></el-table-column>
      <el-table-column prop="gradeName" label="班级名称" align="center" />
      <el-table-column prop="studentCount" label="班级人数" align="center" />
      <el-table-column prop="gradeCode" label="班级代码" align="center" />
      <el-table-column prop="createTime" label="添加时间" align="center">
        <template slot-scope="scope">
          {{ formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <!-- 管理员按钮 -->
          <el-button v-if="role == 3" type="text" size="small" style="font-size: 14px" @click="updateRow(row)">编辑</el-button>
          <el-button v-if="role == 3" type="text" size="small" style="color: red; font-size: 14px" @click="delClass(row)">删除</el-button>
          <!-- 教师按钮 -->
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="updateRow(row)">编辑</el-button>
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="showClass(row)">查看班级</el-button>
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="showAddStudentDialog(row)">添加学生</el-button>
          <el-button v-if="role == 3 || role == 2" type="text" size="small" style="font-size: 14px" @click="importStudent(row)">批量导入学生</el-button>
          <el-button v-if="role == 2" type="text" size="small" style="color: red; font-size: 14px" @click="removeCourseGrade(row)">移除班级</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination :current-page="data.current" :page-sizes="[10, 20, 30, 40]" :page-size="data.size"
        layout="total, sizes, prev, pager, next, jumper" :total="data.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
    <!--新增弹窗-->

    <el-dialog :title="diaTitle" :visible.sync="dialogTableVisible">
      <el-row>
        <el-form :model="addForm">
          <el-form-item label="班级名称" :label-width="formLabelWidth">
            <el-input v-model="addForm.gradeName" autocomplete="off" />
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClass">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="加入班级" :visible.sync="joinClassVisible">
      <el-row>
        <el-form :model="teacharForm">
          <el-form-item label="班级代码：" :label-width="formLabelWidth">
            <el-input v-model="teacharForm.classCode" autocomplete="off" />
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="joinClassVisible = false">取 消</el-button>
        <el-button type="primary" @click="joinClass">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加学生到班级对话框 -->
    <el-dialog title="添加学生到班级" :visible.sync="addStudentVisible" width="60%">
      <el-row>
        <el-form :model="addStudentForm">
          <el-form-item label="班级名称：" :label-width="formLabelWidth">
            <el-input v-model="addStudentForm.gradeName" :disabled="true" />
          </el-form-item>

          <!-- 添加方式选择 -->
          <el-form-item label="添加方式：" :label-width="formLabelWidth">
            <el-radio-group v-model="addStudentMode">
              <el-radio label="search">搜索学号</el-radio>
              <el-radio label="select">从学生列表选择</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 搜索学号方式 -->
          <el-form-item v-if="addStudentMode === 'search'" label="学校：" :label-width="formLabelWidth">
            <el-select v-model="addStudentForm.schoolName" placeholder="请选择学校" style="width: 100%" filterable @change="onSchoolChange">
              <el-option
                v-for="school in schoolList"
                :key="school"
                :label="school"
                :value="school">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addStudentMode === 'search'" label="学生学号：" :label-width="formLabelWidth">
            <el-input v-model="addStudentForm.username" placeholder="请输入学生的学号" autocomplete="off" :disabled="!addStudentForm.schoolName" />
          </el-form-item>

          <!-- 从学生列表选择方式 -->
          <el-form-item v-if="addStudentMode === 'select'" label="选择学生：" :label-width="formLabelWidth">
            <el-select v-model="addStudentForm.selectedStudentId" placeholder="请选择学生" style="width: 100%" filterable>
              <el-option
                v-for="student in unassignedStudents"
                :key="student.id"
                :label="`${student.realName} (${student.userName}) - ${student.school || '未填写学校'}`"
                :value="student.id">
                <span style="float: left">{{ student.realName }} ({{ student.userName }})</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ student.school || '未填写学校' }}</span>
              </el-option>
            </el-select>
            <div style="margin-top: 10px; text-align: right;">
              <el-button size="small" @click="loadUnassignedStudents">刷新学生列表</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStudentToClass">确 定</el-button>
      </div>
    </el-dialog>

    <!--编辑弹窗-->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form :model="form">
            <el-form-item label="班级名称" :label-width="formLabelWidth">
              <el-input v-model="form.gradeName" autocomplete="off" />
              <span style="margin-left: 10px; color: #909399; font-size: 12px;">班级ID: {{ form.gradeId || form.id }}</span>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateClass">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导入学生名单" :visible.sync="uploadExcelVisible" width="900px">
      <div class="import-student-dialog">
        <!-- 步骤1：上传文件 -->
        <div v-if="importStep === 1" class="upload-step">
          <!-- 目标班级信息 - 移动到导入说明前面 -->
          <div v-if="selectedGradeId" class="grade-info-simple">
            <div class="grade-info-header">
              <i class="el-icon-location"></i>
              <span>目标班级信息</span>
            </div>
            <div class="grade-info-content">
              <div class="grade-detail-simple">
                <span class="grade-label">班级名称：</span>
                <span class="grade-value grade-name">{{ selectedGradeName }}</span>
              </div>
              <div class="grade-detail-simple">
                <span class="grade-label">班级ID：</span>
                <span class="grade-value grade-id">{{ selectedGradeId }}</span>
              </div>
            </div>
          </div>

          <!-- 导入说明区域 -->
          <div class="import-tips" style="margin-bottom: 20px; position: relative; z-index: 1;">
            <el-alert
              title="导入说明"
              type="info"
              :closable="false"
              show-icon>
              <div slot="description">
                <p><strong>Excel格式要求：</strong></p>
                <div class="excel-format-example">
                  <table class="format-table">
                    <thead>
                      <tr>
                        <th>学号</th>
                        <th>姓名</th>
                        <th>学校</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>001</td>
                        <td>悉迹</td>
                        <td>北京大学</td>
                      </tr>
                      <tr>
                        <td>002</td>
                        <td>张三</td>
                        <td>清华大学</td>
                      </tr>
                      <tr>
                        <td>003</td>
                        <td>李四</td>
                        <td>复旦大学</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="template-download" style="margin: 15px 0; text-align: center; padding: 10px; background-color: #f8f9fa; border-radius: 4px;">
                  <el-button type="primary" size="medium" @click="downloadTemplate" icon="el-icon-download">
                    下载Excel模板
                  </el-button>
                  <p style="margin-top: 8px; font-size: 12px; color: #666;">点击下载标准格式的Excel模板文件</p>
                </div>
                <p>1. 第一行必须是表头：<strong>学号</strong>、<strong>姓名</strong>、<strong>学校</strong>（学校为可选列）</p>
                <p>2. 支持.xls和.xlsx格式，文件大小不超过5MB</p>
                <p>3. 学号+学校组合不能重复，如果已存在会跳过该条记录</p>
                <p>4. 学号和姓名不能为空，学校可以为空</p>
                <p>5. 不同学校可以有相同的学号</p>
              </div>
            </el-alert>
          </div>

          <div class="upload-section">
            <el-upload
              class="upload-demo"
              drag
              :auto-upload="false"
              :on-change="handleFileChange"
              :before-upload="beforeExcelUpload"
              :file-list="excelFileList"
              accept=".xlsx,.xls"
              :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">仅支持Excel文件（.xls/.xlsx），最大5MB</div>
            </el-upload>
          </div>
        </div>

        <!-- 步骤2：预览和确认 -->
        <div v-if="importStep === 2" class="preview-step">
          <!-- 目标班级信息显示区域 - 简化显示 -->
          <div class="grade-confirmation-section">
            <div v-if="selectedGradeId" class="grade-info-simple">
              <div class="grade-info-header">
                <i class="el-icon-location"></i>
                <span>目标班级信息</span>
              </div>
              <div class="grade-info-content">
                <div class="grade-detail-simple">
                  <span class="grade-label">班级名称：</span>
                  <span class="grade-value grade-name">{{ selectedGradeName }}</span>
                </div>
                <div class="grade-detail-simple">
                  <span class="grade-label">班级ID：</span>
                  <span class="grade-value grade-id">{{ selectedGradeId }}</span>
                </div>
                <div class="import-summary">
                  <el-tag type="info" size="medium">
                    <i class="el-icon-info"></i>
                    将导入 {{ previewData.filter(item => item.status === 'success').length }} 名学生到该班级
                  </el-tag>
                </div>
              </div>
            </div>
            <div v-else class="no-grade-selected">
              <el-alert
                title="未选择班级"
                type="error"
                :closable="false"
                show-icon>
                <template slot="description">
                  <p>请先选择要导入学生的班级</p>
                  <el-button type="primary" size="small" @click="showGradeSelectionDialog">
                    <i class="el-icon-plus"></i>
                    选择班级
                  </el-button>
                </template>
              </el-alert>
            </div>
          </div>

          <div class="preview-header">
            <h4>导入预览</h4>
            <div class="preview-stats">
              <el-tag type="success">共 {{ previewData.length }} 名学生</el-tag>
              <el-tag type="warning" v-if="duplicateCount > 0">{{ duplicateCount }} 名学号+学校重复</el-tag>
            </div>
          </div>

          <div class="preview-table">
            <el-table
              :data="previewData"
              border
              stripe
              height="300"
              :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column prop="studentId" label="学号" width="120" align="center" />
              <el-table-column prop="name" label="姓名" width="120" align="center" />
              <el-table-column prop="schoolName" label="学校" width="150" align="center" />
              <el-table-column prop="status" label="状态" width="100" align="center">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status === 'success' ? 'success' : 'danger'"
                    size="small">
                    {{ scope.row.status === 'success' ? '可导入' : '学号+学校重复' }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="preview-actions">
            <el-button @click="backToUpload">重新选择文件</el-button>
            <el-button type="primary" @click="confirmImport" :loading="importing" :disabled="!selectedGradeId">
              {{ importing ? '导入中...' : '确认导入' }}
            </el-button>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelImport">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 查看班级学生名单弹窗 -->
    <el-dialog title="班级学生名单" :visible.sync="showClassVisible" width="1000px">
      <el-table v-loading="studentListLoading" :data="studentList" border stripe style="width: 100%">
        <el-table-column label="序号" type="index" width="60" align="center" />
        <el-table-column prop="realName" label="姓名" align="center" />
        <el-table-column prop="userName" label="学号" align="center" />
        <el-table-column prop="school" label="学校" align="center" />
        <el-table-column prop="major" label="年级" align="center" />
        <el-table-column prop="parentPhone" label="家长电话" align="center" />
        <el-table-column prop="enrolledAt" label="注册时间" align="center">
          <template slot-scope="scope">
            {{ formatTime(scope.row.enrolledAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editStudent(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: red" @click="removeStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showClassVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 编辑学生信息弹窗 -->
    <el-dialog title="编辑学生信息" :visible.sync="editStudentVisible" width="500px">
      <el-form :model="editStudentForm" :rules="editStudentRules" ref="editStudentForm" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editStudentForm.name" placeholder="请输入学生姓名" />
        </el-form-item>
        <el-form-item label="学号" prop="studentId">
          <el-input v-model="editStudentForm.studentId" placeholder="请输入学号" disabled />
        </el-form-item>
        <el-form-item label="学校" prop="schoolName">
          <el-input v-model="editStudentForm.schoolName" placeholder="请输入学校名称" />
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-input v-model="editStudentForm.grade" placeholder="请输入年级" />
        </el-form-item>
        <el-form-item label="班级" prop="className">
          <el-input v-model="editStudentForm.className" placeholder="请输入班级名称" />
        </el-form-item>
        <el-form-item label="家长电话" prop="parentPhone">
          <el-input v-model="editStudentForm.parentPhone" placeholder="请输入家长电话" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editStudentVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveStudentInfo" :loading="saveStudentLoading">保 存</el-button>
      </div>
    </el-dialog>

    <!-- 课程班级关联对话框 -->
    <el-dialog title="关联班级到课程" :visible.sync="addCourseClassVisible" width="60%">
      <el-row>
        <el-form :model="addCourseClassForm">
          <el-form-item label="课程名称：" :label-width="formLabelWidth">
            <el-input v-model="currentCourseName" :disabled="true" />
          </el-form-item>
          <el-form-item label="选择班级：" :label-width="formLabelWidth">
            <el-select v-model="addCourseClassForm.selectedGradeIds" multiple placeholder="请选择要关联的班级" style="width: 100%">
              <el-option
                v-for="grade in availableGrades"
                :key="grade.id"
                :label="grade.gradeName + ' (' + grade.code + ')'"
                :value="grade.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addCourseClassVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCourseClass" :loading="addCourseClassLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 批量关联班级对话框 -->
    <el-dialog title="批量关联班级到课程" :visible.sync="batchAddCourseClassVisible" width="70%">
      <el-row>
        <el-form :model="batchAddCourseClassForm">
          <el-form-item label="课程名称：" :label-width="formLabelWidth">
            <el-input v-model="currentCourseName" :disabled="true" />
          </el-form-item>
          <el-form-item label="选择班级：" :label-width="formLabelWidth">
            <el-transfer
              v-model="batchAddCourseClassForm.selectedGradeIds"
              :data="availableGradesForTransfer"
              :titles="['可选班级', '已选班级']"
              filterable
              filter-placeholder="请输入班级名称">
            </el-transfer>
          </el-form-item>
        </el-form>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchAddCourseClassVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchAddCourseClass" :loading="batchAddCourseClassLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { teacherJoinClass, teacherExitClass, classPaging, classDel, classUpdate, fetchClass, classAdd, addStudentToClass, addStudentToClassBySchool, getAllSchoolNames, getUnassignedStudents, importStudentList, removeStudentFromClass, updateStudentInfo } from '@/api/class'
import { getGradesByCourseId, getGradesByCourseIdAndTeacherId } from '@/api/course'
// import { createGrade } from '@/api/grade'
import { getRole, getTokenInfo } from '@/utils/jwtUtils'
import * as XLSX from 'xlsx'
export default {
  props: {
    courseId: {
      type: [String, Number],
      required: true
    },
    isTeacher: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadExcelVisible: false,
      excelFileList: [],
      excelFile: null,
      selectedGradeId: null,
      selectedGradeName: '',
      importing: false,
      importStep: 1, // 1: 上传文件, 2: 预览确认
      previewData: [], // 预览数据
      duplicateCount: 0, // 重复学号数量
      XLSX: XLSX, // Excel解析库
      teacharForm: {
        classCode: ''
      },
      addStudentVisible: false,
      addStudentMode: 'search', // 添加方式：search(搜索) 或 select(选择)
      addStudentForm: {
        gradeId: null,
        gradeName: '',
        username: '',
        schoolName: '',
        selectedStudentId: null
      },
      unassignedStudents: [], // 未加入班级的学生列表
      schoolList: [], // 学校列表
      role: 0,
      pageNum: 1,
      pageSize: 10,
      data: {},
      diaTitle: '新增',
      joinClassVisible: false,
      dialogTableVisible: false,
      dialogFormVisible: false,
      addForm: {
        gradeName: ''
      },
      formInline: {
        searchTitle: ''
      },
      form: {
        gradeName: ''
      },
      formLabelWidth: '110px',
      // 学生名单相关
      showClassVisible: false,
      studentList: [],
      studentListLoading: false,
      currentClassName: '',
      currentClassId: null,
      // 编辑学生信息相关
      editStudentVisible: false,
      editStudentForm: {
        id: null,
        name: '',
        studentId: '',
        schoolName: '',
        grade: '',
        className: '',
        parentPhone: ''
      },
      editStudentRules: {
        name: [
          { required: true, message: '请输入学生姓名', trigger: 'blur' }
        ]
      },
      saveStudentLoading: false,
      // 课程班级相关
      courseGrades: [], // 课程关联的班级列表
      userId: null, // 当前用户ID
      // 课程班级关联相关
      addCourseClassVisible: false, // 关联班级对话框显示状态
      batchAddCourseClassVisible: false, // 批量关联班级对话框显示状态
      addCourseClassLoading: false, // 关联班级加载状态
      batchAddCourseClassLoading: false, // 批量关联班级加载状态
      addCourseClassForm: {
        selectedGradeIds: [] // 选中的班级ID列表
      },
      batchAddCourseClassForm: {
        selectedGradeIds: [] // 选中的班级ID列表
      },
      availableGrades: [], // 可选择的班级列表
      availableGradesForTransfer: [], // 用于Transfer组件的班级数据
      currentCourseName: '' // 当前课程名称
    }
  },
  watch: {
    selectedGradeId(newVal, oldVal) {
      console.log('selectedGradeId 发生变化:', {
        from: oldVal,
        to: newVal,
        stack: new Error().stack
      })
    }
  },
  created() {
    this.role = getRole()
    // 获取用户信息
    const userInfo = getTokenInfo()
    if (userInfo) {
      this.userId = userInfo.id
    }
    this.getCourseGrades()
  },
  methods: {
    // 下载Excel模板
    downloadTemplate() {
      try {
        console.log('开始下载Excel模板')

        // 创建模板数据
        const templateData = [
          ['学号', '姓名', '学校'],
          ['001', '张三', '北京大学'],
          ['002', '李四', '清华大学'],
          ['003', '王五', '复旦大学']
        ]

        // 创建工作簿
        const wb = this.XLSX.utils.book_new()
        const ws = this.XLSX.utils.aoa_to_sheet(templateData)

        // 设置列宽
        ws['!cols'] = [
          { wch: 15 }, // 学号列
          { wch: 15 }, // 姓名列
          { wch: 20 } // 学校列
        ]

        // 添加工作表到工作簿
        this.XLSX.utils.book_append_sheet(wb, ws, '学生名单模板')

        // 生成Excel文件并下载
        this.XLSX.writeFile(wb, '学生名单导入模板.xlsx')

        console.log('Excel模板下载完成')
        this.$message.success('模板下载成功')
      } catch (error) {
        console.error('下载Excel模板失败:', error)
        this.$message.error('模板下载失败，请稍后重试')
      }
    },

    // 上传前校验
    beforeExcelUpload(file) {
      const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isExcel) {
        this.$message.error('请上传Excel格式文件')
      }
      if (!isLt5M) {
        this.$message.error('文件大小不能超过5MB')
      }
      this.excelFile = file // 保存文件对象
      return isExcel && isLt5M
    },

    // 手动上传处理
    handleExcelUpload() {
      if (!this.excelFile) {
        return this.$message.error('请先选择文件')
      }
      const formData = new FormData()
      formData.append('file', this.excelFile)
      importStudentApi(formData).then(res => { // 假设后端接口接收FormData格式
        if (res.code === 200) {
          this.uploadExcelVisible = false
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          this.$message.success('学生名单导入成功')
        } else {
          this.$message.error(`导入失败：${res.msg}`)
        }
      })
    },

    // 上传成功回调（如果使用自动上传）
    handleExcelSuccess(res, file) {
      this.$message.success('上传成功')
    },

    // 上传失败回调
    handleExcelError(err, file) {
      this.$message.error('上传失败，请重试')
    },

    // 文件选择变化
    handleFileChange(file, fileList) {
      this.excelFile = file.raw
      this.excelFileList = fileList

      // 自动解析Excel文件并进入预览步骤
      if (this.excelFile) {
        this.parseExcelFile()
      }
    },

    // 取消导入
    cancelImport() {
      this.uploadExcelVisible = false
      this.excelFile = null
      this.excelFileList = []
      this.selectedGradeId = null
      this.selectedGradeName = ''
      this.importStep = 1
      this.previewData = []
      this.duplicateCount = 0
    },

    // 解析Excel文件
    parseExcelFile() {
      if (!this.excelFile) {
        this.$message.warning('请先选择Excel文件')
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const data = e.target.result
          const workbook = this.XLSX.read(data, { type: 'binary' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]

          // 将工作表转换为JSON数组
          const jsonData = this.XLSX.utils.sheet_to_json(worksheet, { header: 1 })

          if (jsonData.length < 2) {
            this.$message.error('Excel文件格式不正确，至少需要包含表头和数据行')
            return
          }

          // 获取表头
          const headers = jsonData[0]
          const studentIdIndex = headers.findIndex(header =>
            header && (header.toString().includes('学号') || header.toString().includes('student_num'))
          )
          const nameIndex = headers.findIndex(header =>
            header && (header.toString().includes('姓名') || header.toString().includes('name'))
          )
          const schoolIndex = headers.findIndex(header =>
            header && (header.toString().includes('学校') || header.toString().includes('school'))
          )

          if (studentIdIndex === -1 || nameIndex === -1) {
            this.$message.error('Excel文件必须包含"学号"和"姓名"列')
            return
          }

          // 解析数据行
          const students = []
          const studentKeySet = new Set() // 使用学号+学校组合作为唯一标识

          for (let i = 1; i < jsonData.length; i++) {
            const row = jsonData[i]
            const studentId = row[studentIdIndex] ? row[studentIdIndex].toString().trim() : ''
            const name = row[nameIndex] ? row[nameIndex].toString().trim() : ''
            const schoolName = schoolIndex !== -1 && row[schoolIndex] ? row[schoolIndex].toString().trim() : ''

            if (studentId && name) {
              // 使用学号+学校组合检查是否重复
              const studentKey = `${studentId}|${schoolName}`
              const isDuplicate = studentKeySet.has(studentKey)
              studentKeySet.add(studentKey)

              students.push({
                studentId: studentId,
                name: name,
                schoolName: schoolName,
                status: isDuplicate ? 'duplicate' : 'success'
              })
            }
          }

          if (students.length === 0) {
            this.$message.error('Excel文件中没有有效的学生数据')
            return
          }

          this.previewData = students
          this.duplicateCount = students.filter(item => item.status === 'duplicate').length
          this.importStep = 2
        } catch (error) {
          console.error('解析Excel文件失败:', error)
          this.$message.error('解析Excel文件失败，请检查文件格式')
        }
      }

      reader.onerror = () => {
        this.$message.error('读取文件失败')
      }

      reader.readAsBinaryString(this.excelFile)
    },

    // 返回上传步骤
    backToUpload() {
      this.importStep = 1
      this.previewData = []
      this.duplicateCount = 0
    },

    // 确认导入
    confirmImport() {
      console.log('=== 确认导入开始 ===')
      console.log('previewData:', this.previewData)
      console.log('selectedGradeId:', this.selectedGradeId, '类型:', typeof this.selectedGradeId)
      console.log('selectedGradeName:', this.selectedGradeName)
      console.log('courseGrades数据:', this.courseGrades)
      console.log('当前组件状态:', {
        uploadExcelVisible: this.uploadExcelVisible,
        importStep: this.importStep,
        importing: this.importing
      })

      if (!this.previewData || this.previewData.length === 0) {
        this.$message.warning('没有可导入的学生数据')
        return
      }

      if (!this.selectedGradeId) {
        console.error('班级ID为空，无法继续导入')
        console.error('可用的班级数据:', this.courseGrades.map(g => ({
          gradeId: g.gradeId,
          id: g.id,
          gradeName: g.gradeName,
          name: g.name
        })))
        this.$message.error('班级ID为空，请重新选择班级')
        return
      }

      // 只导入状态为success的学生
      const validStudents = this.previewData.filter(item => item.status === 'success')
      if (validStudents.length === 0) {
        this.$message.warning('没有可导入的学生数据')
        return
      }

      this.importing = true

      // 构建导入数据
      const importData = {
        students: validStudents,
        gradeId: parseInt(this.selectedGradeId) // 确保gradeId是数字类型
      }

      console.log('导入数据:', importData) // 调试信息
      console.log('班级ID:', this.selectedGradeId, '类型:', typeof this.selectedGradeId)

      importStudentList(importData)
        .then(res => {
          console.log('导入响应:', res) // 调试信息

          // 检查响应状态码（后端返回 code: 1 表示成功）
          if (res.code === 1 || res.code === 200) {
            const successCount = res.data?.successCount || 0
            const skipCount = res.data?.skipCount || 0
            const totalCount = res.data?.totalCount || 0

            if (successCount > 0) {
              // 有成功导入的记录
              let message = `导入成功！共导入 ${successCount} 条学生记录`
              if (skipCount > 0) {
                message += `，跳过 ${skipCount} 条重复记录`
              }
              this.$message.success(message)

              // 关闭对话框并刷新数据
              this.uploadExcelVisible = false
              this.excelFile = null
              this.excelFileList = []
              this.selectedGradeId = null
              this.selectedGradeName = ''
              this.importStep = 1
              this.previewData = []
              this.duplicateCount = 0
              // 刷新班级列表
              this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
            } else {
              // 没有成功导入任何记录
              if (skipCount > 0) {
                this.$message.warning(`导入完成，但所有 ${totalCount} 条记录都因学号+学校组合重复被跳过`)
              } else {
                this.$message.warning('导入完成，但没有成功导入任何记录')
              }
            }
          } else {
            this.$message.error(`导入失败：${res.msg || '未知错误'}`)
          }
        })
        .catch(err => {
          console.error('导入失败:', err)
          this.$message.error('导入失败，请重试')
        })
        .finally(() => {
          this.importing = false
        })
    },
    importStudent(row) {
      console.log('=== 点击导入学生开始 ===')
      console.log('传入的row数据:', row)
      console.log('row的类型:', typeof row)
      console.log('row.gradeId:', row ? row.gradeId : 'undefined')
      console.log('row.gradeName:', row ? row.gradeName : 'undefined')

      if (row) {
        // 如果传入了行数据，直接设置班级信息
        // 尝试多个可能的字段名
        this.selectedGradeId = row.gradeId || row.id
        this.selectedGradeName = row.gradeName || row.name
        console.log('设置后的selectedGradeId:', this.selectedGradeId, '类型:', typeof this.selectedGradeId)
        console.log('设置后的selectedGradeName:', this.selectedGradeName)
        console.log('row对象的所有字段:', Object.keys(row))
        console.log('row.gradeId:', row.gradeId)
        console.log('row.id:', row.id)
      } else {
        // 如果没有传入行数据，需要先选择班级
        this.selectedGradeId = null
        this.selectedGradeName = ''
        console.log('没有传入row数据，清空班级信息')
        this.$message.info('请先选择要导入学生的班级')
        return
      }

      console.log('准备打开导入对话框')
      this.uploadExcelVisible = true
      this.excelFileList = [] // 清空文件列表
      this.excelFile = null
      this.importStep = 1 // 重置到第一步
      this.previewData = []
      this.duplicateCount = 0
      console.log('=== 导入学生设置完成 ===')
    },

    // 显示班级选择对话框
    showGradeSelectionDialog() {
      this.$prompt('请输入班级ID', '选择班级', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\d+$/,
        inputErrorMessage: '班级ID必须是数字'
      }).then(({ value }) => {
        const gradeId = parseInt(value)
        // 查找对应的班级信息，尝试多个可能的字段名
        const grade = this.courseGrades.find(g => (g.gradeId === gradeId) || (g.id === gradeId))
        if (grade) {
          this.selectedGradeId = gradeId
          this.selectedGradeName = grade.gradeName || grade.name
          this.$message.success(`已选择班级：${this.selectedGradeName}`)
        } else {
          this.$message.error('未找到指定的班级，请检查班级ID是否正确')
        }
      }).catch(() => {
        // 用户取消
      })
    },

    joinClass() {
      const params = { code: this.teacharForm.classCode }
      teacherJoinClass(params).then((res) => {
        if (res.code) {
          this.joinClassVisible = false
          // 刷新数据
          if (this.courseId) {
            this.getCourseGrades()
          } else {
            this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          }
          this.$message({
            type: 'success',
            message: '加入成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    exitClass(row) {
      const classId = row['id']
      teacherExitClass(classId).then((res) => {
        if (res.code) {
          // 刷新数据
          if (this.courseId) {
            this.getCourseGrades()
          } else {
            this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
          }
          this.$message({
            type: 'success',
            message: '退出成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    showClass(row) {
      const classId = row.gradeId || row.id
      this.currentClassName = row.gradeName
      this.currentClassId = classId
      this.studentListLoading = true
      this.showClassVisible = true
      this.studentList = []

      // 调用API获取班级学生名单
      fetchClass(classId).then((res) => {
        this.studentListLoading = false
        if (res.code) {
          this.studentList = res.data || []
          if (this.studentList.length === 0) {
            this.$message({
              type: 'info',
              message: '该班级暂无学生!'
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.msg || '获取学生名单失败'
          })
        }
      }).catch(() => {
        this.studentListLoading = false
        this.$message({
          type: 'error',
          message: '获取学生名单失败'
        })
      })
    },
    // 获取课程关联的班级列表
    async getCourseGrades() {
      try {
        console.log('开始获取课程班级数据:', {
          courseId: this.courseId,
          isTeacher: this.isTeacher,
          userId: this.userId,
          role: this.role
        })

        let response
        try {
          // 首先尝试使用课程班级关联API
          console.log('尝试使用课程班级关联API:', this.courseId)
          response = await getGradesByCourseId(this.courseId)
          console.log('课程班级关联API响应:', response)
        } catch (apiError) {
          console.warn('课程班级关联API调用失败，尝试使用班级分页API:', apiError)
          // 如果课程班级关联API失败，使用班级分页API作为备选方案
          const classPagingResponse = await this.getClassPageData()
          if (classPagingResponse) {
            response = { code: 1, data: classPagingResponse }
          } else {
            throw apiError
          }
        }

        if (response.code === 1) {
          this.courseGrades = response.data || []
          console.log('获取到的班级数据:', this.courseGrades)
          console.log('第一个班级数据的字段:', this.courseGrades.length > 0 ? Object.keys(this.courseGrades[0]) : '无数据')

          // 将课程班级数据转换为表格数据格式
          this.data = {
            records: this.courseGrades,
            current: 1,
            size: this.courseGrades.length,
            total: this.courseGrades.length
          }

          // 如果没有数据，显示提示信息
          if (this.courseGrades.length === 0) {
            this.$message.info('该课程暂未关联任何班级，请点击"新增"按钮创建班级')
          } else {
            this.$message.success(`成功加载 ${this.courseGrades.length} 个班级`)
          }
        } else {
          console.error('API返回错误:', response)
          this.$message.error(response.msg || '获取班级列表失败')
          this.data = { records: [], current: 1, size: 0, total: 0 }
        }
      } catch (error) {
        console.error('获取课程班级失败:', error)
        this.$message.error('获取班级列表失败: ' + (error.message || '未知错误'))
        this.data = { records: [], current: 1, size: 0, total: 0 }
      }
    },

    // 获取班级分页数据作为备选方案
    async getClassPageData() {
      try {
        const { classPaging } = await import('@/api/class')
        const params = { pageNum: 1, pageSize: 100, gradeName: null }
        const res = await classPaging(params)
        console.log('班级分页API响应:', res)

        if (res.code === 1 && res.data && res.data.records) {
          // 将班级分页数据转换为课程班级格式
          return res.data.records.map(grade => ({
            id: grade.id,
            gradeId: grade.id,
            gradeName: grade.gradeName,
            gradeCode: grade.code,
            studentCount: grade.gradeCount || 0, // 使用gradeCount作为班级人数
            createTime: grade.createTime
          }))
        }
        return []
      } catch (error) {
        console.error('获取班级分页数据失败:', error)
        return []
      }
    },

    // 分页查询（保留原方法以兼容其他功能）
    async getClassPage(pageNum, pageSize, title = null) {
      // 如果是在课程详情页面，使用课程班级数据
      if (this.courseId) {
        this.getCourseGrades()
        return
      }
      // 否则使用原来的班级分页查询（用于主页班级管理）
      const params = { pageNum: pageNum, pageSize: pageSize, gradeName: title }
      const res = await classPaging(params)
      this.data = res.data
    },
    async addClass() {
      const data = { gradeName: this.addForm.gradeName }
      try {
        const res = await classAdd(data)
        if (res.code) {
          this.addForm.gradeName = ''

          // 如果是在课程详情页面，需要建立课程班级关联
          if (this.courseId) {
            try {
              // 获取新创建的班级ID
              const newGradeId = res.data
              if (newGradeId) {
                console.log('新创建的班级ID:', newGradeId)
                // 建立课程班级关联
                const { batchAddCourseGrades } = await import('@/api/course')
                const linkRes = await batchAddCourseGrades(this.courseId, [newGradeId])
                console.log('关联结果:', linkRes)
                if (linkRes.code === 1) {
                  this.$message.success('班级创建并关联成功!')
                } else {
                  this.$message.warning('班级创建成功，但关联失败: ' + linkRes.msg)
                }
              } else {
                this.$message.warning('班级创建成功，但无法获取班级ID')
              }
            } catch (linkError) {
              console.error('建立课程班级关联失败:', linkError)
              this.$message.warning('班级创建成功，但关联失败: ' + linkError.message)
            }

            // 刷新数据
            this.getCourseGrades()
          } else {
            // 在主页班级管理中，使用原来的逻辑
            this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
            this.$message.success('新增成功!')
          }

          this.dialogTableVisible = false
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      } catch (error) {
        console.error('创建班级失败:', error)
        this.$message.error('创建班级失败: ' + (error.message || '未知错误'))
      }
    },
    delClass(row) {
      this.$confirm('此操作将永久删除该班级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          classDel(row.gradeId || row.id).then((res) => {
            if (res.code) {
              // 刷新数据
              if (this.courseId) {
                this.getCourseGrades()
              } else {
                this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
              }
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    updateClass() {
      // 使用正确的班级ID：优先使用gradeId，如果没有则使用id
      const classId = this.form.gradeId || this.form.id
      console.log('编辑班级信息:', {
        form: this.form,
        classId: classId,
        gradeName: this.form.gradeName
      })

      classUpdate(classId, { gradeName: this.form.gradeName })
        .then((res) => {
          if (res.code) {
            // 刷新数据
            if (this.courseId) {
              this.getCourseGrades()
            } else {
              this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
            }
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: '编辑成功!'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消编辑'
          })
        })
    },
    updateRow(row) {
      this.dialogFormVisible = true
      this.form = row
    },
    searchExam() {
      if (this.courseId) {
        // 在课程班级管理模式下，搜索功能暂时不支持
        this.$message.info('课程班级管理模式下暂不支持搜索功能')
      } else {
        this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
      }
    },
    handleClick(row) {
      // TODO: 处理行点击事件
      console.log('Row clicked:', row)
    },
    handleSizeChange(val) {
      // 设置每页多少条逻辑
      this.pageSize = val
      if (this.courseId) {
        // 课程班级管理模式下，分页功能暂时不支持
        this.$message.info('课程班级管理模式下暂不支持分页功能')
      } else {
        this.getClassPage(this.pageNum, val)
      }
    },
    handleCurrentChange(val) {
      // 设置当前页逻辑
      this.pageNum = val
      if (this.courseId) {
        // 课程班级管理模式下，分页功能暂时不支持
        this.$message.info('课程班级管理模式下暂不支持分页功能')
      } else {
        this.getClassPage(val, this.pageSize)
      }
    },

    // 显示添加学生对话框
    showAddStudentDialog(row) {
      this.addStudentForm.gradeId = row.gradeId || row.id
      this.addStudentForm.gradeName = row.gradeName
      this.addStudentForm.username = ''
      this.addStudentForm.schoolName = ''
      this.addStudentForm.selectedStudentId = null
      this.addStudentMode = 'search'
      this.addStudentVisible = true
      // 加载学校列表和学生列表
      this.loadSchoolList()
      this.loadUnassignedStudents()
    },

    // 添加学生到班级
    addStudentToClass() {
      if (this.addStudentMode === 'search') {
        // 搜索学号方式
        if (!this.addStudentForm.schoolName) {
          this.$message.warning('请选择学校')
          return
        }
        if (!this.addStudentForm.username.trim()) {
          this.$message.warning('请输入学生学号')
          return
        }

        // 使用新的API，根据学校+学号添加学生
        addStudentToClassBySchool(this.addStudentForm.gradeId, this.addStudentForm.username.trim(), this.addStudentForm.schoolName)
          .then((res) => {
            this.handleAddStudentSuccess(res)
          })
          .catch((error) => {
            this.handleAddStudentError(error)
          })
      } else if (this.addStudentMode === 'select') {
        // 从列表选择方式
        if (!this.addStudentForm.selectedStudentId) {
          this.$message.warning('请选择要添加的学生')
          return
        }
        // 根据选中的学生ID找到对应的用户名
        const selectedStudent = this.unassignedStudents.find(s => s.id === this.addStudentForm.selectedStudentId)
        if (!selectedStudent) {
          this.$message.error('选中的学生信息不存在')
          return
        }

        // 使用原有的API，根据学号添加学生
        addStudentToClass(this.addStudentForm.gradeId, selectedStudent.userName)
          .then((res) => {
            this.handleAddStudentSuccess(res)
          })
          .catch((error) => {
            this.handleAddStudentError(error)
          })
      }
    },

    // 处理添加学生成功
    handleAddStudentSuccess(res) {
      if (res.code) {
        this.addStudentVisible = false
        this.addStudentForm.username = ''
        this.addStudentForm.schoolName = ''
        this.addStudentForm.selectedStudentId = null
        // 刷新数据
        if (this.courseId) {
          this.getCourseGrades()
        } else {
          this.getClassPage(this.pageNum, this.pageSize, this.formInline.searchTitle)
        }
        // 刷新未加入班级的学生列表
        this.loadUnassignedStudents()
        this.$message({
          type: 'success',
          message: res.msg || '添加学生成功!'
        })
      } else {
        this.$message({
          type: 'error',
          message: res.msg || '添加学生失败'
        })
      }
    },

    // 处理添加学生失败
    handleAddStudentError(error) {
      console.error('添加学生失败:', error)
      this.$message({
        type: 'error',
        message: '添加学生失败，请稍后重试'
      })
    },

    // 加载学校列表
    loadSchoolList() {
      getAllSchoolNames()
        .then((res) => {
          if (res.code) {
            this.schoolList = res.data || []
          } else {
            console.error('获取学校列表失败:', res.msg)
            this.schoolList = []
          }
        })
        .catch((error) => {
          console.error('获取学校列表失败:', error)
          this.schoolList = []
        })
    },

    // 学校选择变化时的处理
    onSchoolChange() {
      // 清空学号输入框
      this.addStudentForm.username = ''
    },

    // 加载未加入班级的学生列表
    loadUnassignedStudents() {
      getUnassignedStudents()
        .then((res) => {
          if (res.code) {
            this.unassignedStudents = res.data || []
          } else {
            console.error('获取未加入班级学生列表失败:', res.msg)
            this.unassignedStudents = []
          }
        })
        .catch((error) => {
          console.error('获取未加入班级学生列表失败:', error)
          this.unassignedStudents = []
        })
    },

    // 移除课程班级关联
    removeCourseGrade(row) {
      this.$confirm('确定要移除该班级与课程的关联吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          // 这里需要调用删除课程班级关联的API
          // 由于当前API中没有直接的删除接口，我们需要添加
          this.$message.info('移除功能开发中...')
          // TODO: 实现移除课程班级关联的功能
        })
        .catch(() => {
          this.$message.info('已取消移除')
        })
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    // 课程班级关联相关方法
    // 显示关联班级对话框
    async showAddCourseClassDialog() {
      this.addCourseClassVisible = true
      this.addCourseClassForm.selectedGradeIds = []
      await this.loadAvailableGrades()
      await this.loadCurrentCourse()
    },

    // 显示批量关联班级对话框
    async showBatchAddCourseClassDialog() {
      this.batchAddCourseClassVisible = true
      this.batchAddCourseClassForm.selectedGradeIds = []
      await this.loadAvailableGrades()
      await this.loadCurrentCourse()
    },

    // 加载可选择的班级列表
    async loadAvailableGrades() {
      try {
        const response = await classPaging({ pageNum: 1, pageSize: 1000 })
        if (response.code === 1) {
          this.availableGrades = response.data.records || []
          // 为Transfer组件准备数据
          this.availableGradesForTransfer = this.availableGrades.map(grade => ({
            key: grade.id,
            label: `${grade.gradeName} (${grade.code})`
          }))
        }
      } catch (error) {
        console.error('加载班级列表失败:', error)
        this.$message.error('加载班级列表失败')
      }
    },

    // 加载当前课程信息
    async loadCurrentCourse() {
      // 由于当前组件已经在课程详情页面，可以通过其他方式获取课程名称
      // 这里暂时使用课程ID作为显示
      this.currentCourseName = `课程 ID: ${this.courseId}`
      // TODO: 如果需要显示真实的课程名称，可以调用获取课程详情的API
    },

    // 关联班级到课程
    async addCourseClass() {
      if (!this.addCourseClassForm.selectedGradeIds.length) {
        this.$message.warning('请至少选择一个班级')
        return
      }

      this.addCourseClassLoading = true
      try {
        // 调用批量添加API
        const { batchAddCourseGrades } = await import('@/api/course')
        const response = await batchAddCourseGrades(this.courseId, this.addCourseClassForm.selectedGradeIds)

        if (response.code === 1) {
          this.$message.success('班级关联成功')
          this.addCourseClassVisible = false
          // 刷新数据
          this.getCourseGrades()
        } else {
          this.$message.error(response.msg || '关联失败')
        }
      } catch (error) {
        console.error('关联班级失败:', error)
        this.$message.error('关联班级失败')
      } finally {
        this.addCourseClassLoading = false
      }
    },

    // 批量关联班级到课程
    async batchAddCourseClass() {
      if (!this.batchAddCourseClassForm.selectedGradeIds.length) {
        this.$message.warning('请至少选择一个班级')
        return
      }

      this.batchAddCourseClassLoading = true
      try {
        // 调用批量添加API
        const { batchAddCourseGrades } = await import('@/api/course')
        const response = await batchAddCourseGrades(this.courseId, this.batchAddCourseClassForm.selectedGradeIds)

        if (response.code === 1) {
          this.$message.success(`成功关联 ${this.batchAddCourseClassForm.selectedGradeIds.length} 个班级`)
          this.batchAddCourseClassVisible = false
          // 刷新数据
          this.getCourseGrades()
        } else {
          this.$message.error(response.msg || '批量关联失败')
        }
      } catch (error) {
        console.error('批量关联班级失败:', error)
        this.$message.error('批量关联班级失败')
      } finally {
        this.batchAddCourseClassLoading = false
      }
    },

    // 编辑学生信息
    editStudent(row) {
      this.editStudentForm = {
        id: row.id,
        name: row.realName || '',
        studentId: row.userName || '',
        schoolName: row.school || '',
        grade: row.major || '',
        className: row.className || '',
        parentPhone: row.parentPhone || ''
      }
      this.editStudentVisible = true
    },

    // 保存学生信息
    saveStudentInfo() {
      this.$refs.editStudentForm.validate((valid) => {
        if (valid) {
          this.saveStudentLoading = true
          const studentData = {
            name: this.editStudentForm.name,
            schoolName: this.editStudentForm.schoolName,
            grade: this.editStudentForm.grade,
            className: this.editStudentForm.className,
            parentPhone: this.editStudentForm.parentPhone
          }

          updateStudentInfo(this.editStudentForm.id, studentData)
            .then((res) => {
              this.saveStudentLoading = false
              if (res.code === 1 || res.code === 200) {
                this.$message.success('学生信息更新成功')
                this.editStudentVisible = false
                // 刷新学生列表
                this.showClass({ gradeId: this.currentClassId, gradeName: this.currentClassName })
              } else {
                this.$message.error(res.msg || '更新失败')
              }
            })
            .catch((error) => {
              this.saveStudentLoading = false
              console.error('更新学生信息失败:', error)
              this.$message.error('更新失败，请稍后重试')
            })
        }
      })
    },

    // 删除学生
    removeStudent(row) {
      this.$confirm(`确定要删除学生"${row.realName}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        removeStudentFromClass(this.currentClassId, row.id)
          .then((res) => {
            if (res.code === 1 || res.code === 200) {
              this.$message.success('学生已从班级中移除')
              // 刷新学生列表
              this.showClass({ gradeId: this.currentClassId, gradeName: this.currentClassName })
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          })
          .catch((error) => {
            console.error('删除学生失败:', error)
            this.$message.error('删除失败，请稍后重试')
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style>
.el-table--border,
.el-table--group {
  border: 1px solid #b3b3b3;
}

.bj {
  margin-top: 40px;
  margin-left: 30px;
}
.upload-demo {
  width: 100%;
  text-align: center;
  padding: 30px 20px;
  border: 2px dashed #e0e0e0;
  border-radius: 6px;
  cursor: pointer;
}

.upload-demo .el-upload__text {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}

.upload-demo .el-upload__tip {
  margin-top: 5px;
  font-size: 12px;
  color: #999;
}

/* 课程班级管理样式 */
.course-class-management .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.course-class-management .section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.course-class-management .class-actions {
  display: flex;
  gap: 10px;
}

.course-class-management .class-actions .el-button {
  font-size: 14px;
}

/* 导入学生对话框样式 */
.import-student-dialog {
  padding: 20px 0;
}

.import-tips {
  margin-bottom: 20px;
}

.import-tips .el-alert {
  margin-bottom: 0;
}

.import-tips p {
  margin: 5px 0;
  font-size: 14px;
  color: #606266;
}

.upload-section {
  margin: 20px 0;
}

.grade-info {
  margin-top: 15px;
}

.grade-info-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #303133;
  margin-bottom: 10px;
}

.grade-info-header i {
  margin-right: 8px;
  color: #409EFF;
}

.grade-info-content {
  padding: 10px 0;
}

.grade-detail {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.grade-label {
  font-weight: bold;
  color: #606266;
  min-width: 80px;
  margin-right: 10px;
}

.grade-value {
  font-size: 14px;
  color: #303133;
}

.grade-value.grade-name {
  color: #409EFF;
  font-weight: bold;
}

.grade-value.grade-id {
  color: #67C23A;
  font-weight: bold;
  font-family: 'Courier New', monospace;
  background-color: #f0f9ff;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #b3d8ff;
}

/* 班级信息确认区域样式 */
.grade-confirmation-section {
  margin: 10px 0 15px 0;
}

.grade-info-display {
  padding: 10px 0;
}

.selected-grade-info .info-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.selected-grade-info .label {
  font-weight: bold;
  color: #606266;
  min-width: 80px;
  margin-right: 10px;
}

.selected-grade-info .value {
  font-size: 16px;
  color: #303133;
}

.selected-grade-info .grade-name {
  color: #409EFF;
  font-weight: bold;
}

.selected-grade-info .grade-id {
  color: #67C23A;
  font-weight: bold;
  font-family: 'Courier New', monospace;
  background-color: #f0f9ff;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #b3d8ff;
}

.import-summary {
  margin-top: 15px;
  text-align: center;
}

.import-summary .el-tag {
  font-size: 14px;
  padding: 8px 16px;
}

.no-grade-selected {
  text-align: center;
}

.no-grade-selected .el-alert {
  margin-bottom: 15px;
}

.no-grade-selected .el-button {
  margin-top: 10px;
}

/* Excel格式示例样式 */
.excel-format-example {
  margin: 15px 0;
  overflow-x: auto;
}

.format-table {
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 14px;
  min-width: 300px;
  width: 100%;
  border: 1px solid #ddd;
}

.format-table th {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: bold;
  text-align: center;
  border: 1px solid #ddd;
  padding: 8px 12px;
}

.format-table td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: center;
  background-color: #fff;
}

.format-table tbody tr:nth-child(even) td {
  background-color: #fafafa;
}

.grade-info .el-tag {
  font-size: 14px;
  padding: 8px 16px;
}

/* 预览步骤样式 */
.preview-step {
  padding: 20px 0;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.preview-header h4 {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.preview-stats {
  display: flex;
  gap: 10px;
}

.preview-table {
  margin: 10px 0;
}

.preview-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #e4e7ed;
}

/* 上传步骤样式 */
.upload-step {
  padding: 20px 0;
}

/* 简化的目标班级信息样式 */
.grade-info-simple {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.grade-info-simple .grade-info-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #303133;
  margin-bottom: 12px;
  font-size: 16px;
}

.grade-info-simple .grade-info-header i {
  margin-right: 8px;
  color: #409EFF;
  font-size: 18px;
}

.grade-info-simple .grade-info-content {
  padding: 0;
}

.grade-detail-simple {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 14px;
}

.grade-detail-simple .grade-label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  margin-right: 10px;
}

.grade-detail-simple .grade-value {
  font-size: 14px;
  color: #303133;
}

.grade-detail-simple .grade-value.grade-name {
  color: #409EFF;
  font-weight: bold;
}

.grade-detail-simple .grade-value.grade-id {
  color: #67C23A;
  font-weight: bold;
  font-family: 'Courier New', monospace;
  background-color: #f0f9ff;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #b3d8ff;
}

.grade-info-simple .import-summary {
  margin-top: 12px;
  text-align: center;
}

.grade-info-simple .import-summary .el-tag {
  font-size: 14px;
  padding: 6px 12px;
}
</style>
